import { createSlice } from "@reduxjs/toolkit";
import { PREFERENCE_IDENTIFIERS } from "../../../util/constants";
import { selectBuckeyeLinkLinks } from "./buckeye-link";
import { findBuckeyeLinkMatch } from "../../data-sources/aws-lambda/preferences";
import { sortByStringField } from "../../../util/functions";

const initialState = {
  search: {},
  quickLinks: []
};

const preferences = createSlice({
  name: "preferences",
  initialState,
  reducers: {
    initializePreferences: (state, action) => {
      const prefs = Array.isArray(action.payload) ? action.payload : []
      const preferencesForSearch = prefs.find(({ key }) => key.startsWith(PREFERENCE_IDENTIFIERS.SEARCH))?.search

      if(Array.isArray(preferencesForSearch)) {
        preferencesForSearch.forEach(({ type, links = []}) => {
          if(type && links?.length) {
            state.search[type] = links
          }
        })
      }
      
    },
    setQuickLinkPreferences: (state, action) => {
      if(action?.payload?.length >= 3) {
        state.quickLinks = action.payload
      } else {
        state.quickLinks = []
      }
    },
    setPreferences: (state, action) => {
      const { query, links = []} = action?.payload ?? {}
      if(query) {
        state.search[query] = links
      }
    }
  }
});

export const { initializePreferences, setPreferences, setQuickLinkPreferences } = preferences.actions
const reducers = {
  getPreferences: preferences.reducer,
};

export const selectPreferences = (state = {}, query) => {  
  const searchPrefs = state.preferences?.search ?? {}
  if(query) {
    return searchPrefs[query]
  }
  
  return searchPrefs
};

export const selectFavoritedLinks = (state = {}, query) => {  
  const preferences = selectPreferences(state)
  const blData = selectBuckeyeLinkLinks(state)
  let favoritedLinks = []
  Object.entries(preferences).forEach(([searchType, preferences = []]) => {
    preferences.forEach(preference => {
      const matchInBl = findBuckeyeLinkMatch(blData, preference)
      favoritedLinks.push({
        query: searchType,
        favoritable: true,
        ...preference,
        ...matchInBl ?? {}
      })
    })
  })

  return sortByStringField(favoritedLinks ?? [], 'title')
};


export const selectStoredQuickLinkPreferences = (state = {}) => {  
  const quickLinks = state.preferences?.quickLinks ?? []
  
  return quickLinks
};

export default reducers;